import { render, staticRenderFns } from "./CourseInsideTitle.vue?vue&type=template&id=931c63f4&scoped=true&"
import script from "./CourseInsideTitle.vue?vue&type=script&lang=js&"
export * from "./CourseInsideTitle.vue?vue&type=script&lang=js&"
import style0 from "./CourseInsideTitle.vue?vue&type=style&index=0&id=931c63f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931c63f4",
  null
  
)

export default component.exports